// Scroll Down

$('#scroll-btn').on("click", function() {
  var percentageToScroll = 100;
  var height = $('.banner-item').innerHeight();
  var scrollAmount = (height * percentageToScroll / 100) - 90;
  $("html, body").animate({
    scrollTop: scrollAmount
  }, 1000);
});

$('#scroll-btn-top').on('click',function() {
	$("html, body").animate({ scrollTop: 0 }, 500);
})